import {useContext } from "react";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import LocationDrawer from "./LocationDrawer";
import { ReviewsDrawer } from "./ReviewsDrawer";
import { PostsDrawer } from "./PostsDrawer";
import { LogsDrawer } from "../../../pages/common/sideMenu/Logs/LogsDrawer";
import { UserDrawer } from "../../../pages/common/Drawers/UserDrawer";
import { ScheduledPostsDrawer } from "./ScheduledPostsDrawer";
import { LocationViewAndConversionStatsDrawer } from "./LocationViewAndConversionStatsDrawer";
import { LocationReviewsStatsDrawer } from "./LocationReviewsStatsDrawer";
import { LocationContentStatsDrawer } from "./LocationContentStatsDrawer";
import { ConfigureIADrawer } from "../../../pages/menuReviews/3_1_Reviews/Reviews/drawer/ConfigureIADrawer";
import { ConfigureIAByLocalDrawer } from "../../../pages/menuReviews/3_1_Reviews/Reviews/drawer/ConfigureIAByLocalDrawer";
import { ReleaseNotesModal } from "../../../pages/home/ReleaseNotesModal";

const AllDrawers = () => {

  const {
    locationDrawer, 
    locationViewAdnConversionStatsDrawer, 
    locationReviewsStatsDrawer, 
    locationContentStatsDrawer, 
    reviewsDrawer, 
    postsDrawer, 
    scheduledPostsDrawer, 
    logsDrawer, 
    userDrawer,
    configureIADrawer,
    configureIAByLocalDrawer,
    releaseNotesModal
  } = useContext(DrawerContext)
  
  return (
    <>
        {locationDrawer && <LocationDrawer/>}
        {locationReviewsStatsDrawer && <LocationReviewsStatsDrawer/>}
        {locationContentStatsDrawer && <LocationContentStatsDrawer/>}
        {locationViewAdnConversionStatsDrawer && <LocationViewAndConversionStatsDrawer/>}
        {reviewsDrawer && <ReviewsDrawer/>}
        {postsDrawer && <PostsDrawer/>}
        {scheduledPostsDrawer && <ScheduledPostsDrawer/>}
        {logsDrawer && <LogsDrawer/>}
        {userDrawer && <UserDrawer/>}
        {configureIADrawer && <ConfigureIADrawer/>}
        {configureIAByLocalDrawer && <ConfigureIAByLocalDrawer/>}
        {releaseNotesModal && <ReleaseNotesModal/>}
    </>
  )
}

export default AllDrawers;